module.exports = __webpack_public_path__ + "media/logos/forbes-logo-white-small-b42d9f84.png";